
import Global from "../../../assets/duotone/Global.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function GlobalIcon({ className, dataTestid = "GlobalIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Global data-testid={dataTestid} className={classes} {...rest} />
  );
}
